var styles = {
  scanModuleButtons: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  manualEntryModuleButtons: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "2rem",
  },
  buttonItem: {
    flexBasis: "40%",
  },
  packageList: {
    maxHeight: "30vh",
    overflow: "auto",
  },
  reasonCodeButtonGroup: {
    display: "flex",
    justifyContent: "center",
    padding: "1rem",
    width: "100%",
  },
  manualEntryTextField: {
    width: "100%",
    marginBottom: "1.5rem",
  },
  camButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imagePreviewContainer: {
    marginTop: "1rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imagePreview: {
    width: "50%",
    height: "50%",
  },
  closeButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  webcamContainer: {
    position: "relative" as const,
  },
  webcamOverlay: {
    position: "absolute" as const,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    marginTop: 0,
    marginLeft: 0,
    width: "100%",
    height: "98%",
  },
  innerRectangle: {
    border: "2px green ridge",
    width: "70%",
    height: "60%",
  },
};

export default styles;
